<template>
  <div :class="'iq-card ' + className">
    <slot name="cardImage"></slot>
    <div v-if="hasSlot('headerTitle') || hasSlot('headerAction')" :class="'iq-card-header d-flex justify-content-between '+headerClass">
      <div class="iq-header-title">
        <slot name="headerTitle"></slot>
      </div>
      <div class="iq-card-header-toolbar d-flex align-items-center">
        <slot name="headerAction"></slot>
      </div>
    </div>
    <main :body-class="'iq-card-body' + bodyClass">
        <slot></slot>
    </main>
    <b-card-body :body-class="'iq-card-body' + bodyClass" v-if="hasSlot('body')">
      <slot name="body"></slot>
    </b-card-body>
    <div v-if="hasSlot('footer')" :class="'card-footer' + footerClass">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'iq-card',
  props: {
    className: { type: String, default: '' },
    bodyClass: { type: String, default: '' },
    headerClass: { type: String, default: '' },
    footerClass: { type: String, default: '' }
  },
  setup(props, { slots }) {
    const hasSlot = name => !!slots[name]
    return { hasSlot }
  },
}
</script>

<style scoped>
  main {
    padding: 20px;
  }

</style>
